/**
 * Configuration for the Ordering prompt form.
 */

import type { PresetButton } from '../types';
import type { OrderingFormState } from './types';

const TOPIC_PRESET =
    'Tạo câu hỏi về chủ đề [chủ đề], thuộc môn học [môn học], trình độ [level], dành cho đối tượng [đối tượng]';
const DOCUMENT_PRESET =
    'Dựa trên nội dung trong file đính kèm của tôi, hãy tạo câu hỏi thuộc môn học [môn học], trình độ [level], dành cho đối tượng [đối tượng]';

const DEFAULT_PRESETS: PresetButton[] = [
    { key: 'topic', value: TOPIC_PRESET, label: 'Tạo theo chủ đề', icon: 'BookOpen' },
    { key: 'document', value: DOCUMENT_PRESET, label: 'Tạo từ tài liệu', icon: 'FileText' },
];

export const QUESTION_TYPE_PRESETS: Record<string, PresetButton[]> = {
    'ordering': DEFAULT_PRESETS,
};

export interface QuickCreateTemplate {
    slug: string;
    defaults: OrderingFormState;
}

export const QUICK_CREATE_TEMPLATES: QuickCreateTemplate[] = [
    {
        slug: 'ordering',
        defaults: {
            media: 'none',
            num_items: 5,
            sourceType: 'topic',
            description: '',
            documents: [],
        },
    },
];
